import { seoLocales } from "@/translations/config";

import { Locale } from "@/types/locale";

import { generateHost } from "./util";

export const buildIndexUrl = (host: string, locale: Locale) => {
    const url = new URL(`${host}/${locale}`);
    url.search = "";
    url.hash = "";
    return url.toString();
};

export const buildSiteUrl = (path: string, host: string, locale: Locale) => {
    const url = new URL(`/${locale}${path}`, host);
    url.search = "";
    url.hash = "";
    return url.toString();
};

export const generateAlternateLinks = () => {
    const urls = seoLocales.map((locale) => {
        const host = generateHost(locale);
        const url = buildIndexUrl(host, locale);
        return { url, locale };
    });
    return urls;
};
